import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { FileText } from 'lucide-react';

export function GenericComparison({ check, verificationData, handleFieldVerification }) {
    const candidateData = {
      ...(check?.subcheck_data || {}),
      father_name: check?.father_name || check?.subcheck_data?.father_name || '',
      dob: check?.dob || check?.subcheck_data?.dob || check?.subcheck_data?.date_of_birth || '',
      candidate_name: check?.subcheck_data?.candidate_name || check?.subcheck_data?.name || check?.employee_name || '',
    };
    const fields = Object.keys(candidateData).filter(
      k => !['id', 'status', 'type', 'created_at', 'updated_at'].includes(k)
    );
    
    return (
      <div className="space-y-4">
        <h4 className="font-semibold text-sm flex items-center gap-2">
          <FileText className="w-4 h-4" />
          {check?.subcheck_type || check?.check_type?.replace(/_/g, ' ')} Verification
        </h4>
        
        <div className="grid grid-cols-2 gap-4">
          {/* Candidate Provided */}
          <Card className="border-blue-200 bg-blue-50/50">
            <CardHeader className="pb-2">
              <CardTitle className="text-sm text-blue-800">Candidate Provided</CardTitle>
            </CardHeader>
            <CardContent className="space-y-2 text-sm">
              {fields.map(field => (
                <div key={field}>
                  <span className="text-gray-500">{field.replace(/_/g, ' ')}:</span>{' '}
                  {typeof candidateData[field] === 'object' 
                    ? JSON.stringify(candidateData[field]) 
                    : String(candidateData[field] || '-')}
                </div>
              ))}
            </CardContent>
          </Card>
          
          {/* Verified Details */}
          <Card className="border-green-200 bg-green-50/50">
            <CardHeader className="pb-2">
              <CardTitle className="text-sm text-green-800">Verified Details</CardTitle>
            </CardHeader>
            <CardContent className="space-y-2">
              {fields.map(field => (
                <div key={field} className="space-y-1">
                  <Label className="text-xs capitalize">{field.replace(/_/g, ' ')}</Label>
                  <Input 
                    value={verificationData.verified_details[field] || ''} 
                    onChange={(e) => handleFieldVerification(field, true, e.target.value)}
                    className="h-8 text-sm"
                  />
                </div>
              ))}
            </CardContent>
          </Card>
        </div>
      </div>
    );
}
